(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/best-bet-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/best-bet-rows.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo;
const _svs$tipsen$component = svs.tipsen.components.bestBetRows,
  useBestBetRows = _svs$tipsen$component.useBestBetRows,
  SingleRowsPresentation = _svs$tipsen$component.SingleRowsPresentation,
  SingleRow = _svs$tipsen$component.SingleRow;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('tipsen:best-bet-rows');
const BestBetRows = () => {
  const getBestBetRows = useBestBetRows();
  const _getBestBetRows = getBestBetRows(),
    bestBetRows = _getBestBetRows.bestBetRows,
    drawResultOutcomes = _getBestBetRows.drawResultOutcomes,
    winDivisions = _getBestBetRows.winDivisions,
    productId = _getBestBetRows.productId;
  const eventTypeId = productId ? getDefinitionByProduct(productId).outcomes.eventTypeId : 0;
  const bestBetRowComponents = useMemo(() => {
    if (!(bestBetRows !== null && bestBetRows !== void 0 && bestBetRows.length)) {
      return null;
    }
    const rows = [];
    const numMatches = drawResultOutcomes.length;
    for (const _ref of bestBetRows.entries()) {
      var _ref2 = _slicedToArray(_ref, 2);
      const groupNumber = _ref2[0];
      const group = _ref2[1];
      if (!group.length) {
        continue;
      }
      rows.push(...group.map((row, index) => {
        const totalCorrects = drawResultOutcomes.length ? numMatches - groupNumber : '-';
        const winDiv = groupNumber + 1;
        return React.createElement(SingleRow, {
          className: winDivisions.includes(winDiv) ? 'pg_best_bet_rows__row--is-in-pricegroup' : '',
          drawResultOutcomes: drawResultOutcomes,
          eventTypeId: eventTypeId
          ,
          key: row.join('') + index,
          row: row,
          topic: totalCorrects
        });
      }));
    }
    logger.debug('Rerendered BestBetRows components');
    return rows;
  }, [bestBetRows, winDivisions, drawResultOutcomes, eventTypeId]);
  return React.createElement(SingleRowsPresentation, null, bestBetRowComponents);
};
setGlobal('svs.tipsen.components.bestBetRows.BestBetRows', BestBetRows);

 })(window);